const error404 = {
    title: 'Kļūda 404',
    header: 'Diemžēl, šādu lapu neizdodas atrast',
    message: "😳",
    link: "Atgriezties uz sākumu",
}

export default error404
